import { Calculator } from "lucide-react";

export const CountryData = [
  {
    name: "canada",
    imageURL:
      "https://images.unsplash.com/photo-1530025809667-1f4bcff8e60f?q=80&w=2891&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    tagline:
      "Explore breathtaking landscapes, vibrant cities, and rich culture",

    // Eligibility Requirements
    eligibilityRequirements: {
      title: "Eligibility Requirements to Study in Canada",
      requirements: [
        {
          category: "Academic Requirements",
          items: [
            "Minimum 60% in 12th grade for undergraduate programs",
            "Bachelor's degree for postgraduate programs",
            "Transcripts and mark sheets from recognized boards",
          ],
        },
        {
          category: "English Proficiency",
          items: [
            "IELTS: Overall 6.5 (no band less than 6.0)",
            "TOEFL iBT: 88-100 depending on program",
            "PTE: 58-65 overall score",
            "Duolingo: 120+ (some institutions)",
          ],
        },
        {
          category: "Financial Requirements",
          items: [
            "Proof of funds: CAD 20,000-25,000 per year",
            "Tuition fee payment proof",
            "Bank statements for last 6 months",
            "Education loan sanction letter (if applicable)",
          ],
        },
        {
          category: "Additional Documents",
          items: [
            "Valid passport",
            "Statement of Purpose (SOP)",
            "Letters of Recommendation",
            "Work experience certificates (if any)",
          ],
        },
      ],
    },

    // Application Process
    applicationProcess: {
      title: "Application Process to Study in Canada",
      steps: [
        {
          step: 1,
          title: "Research & Choose Program",
          description:
            "Research universities, programs, and admission requirements",
          duration: "2-3 weeks",
        },
        {
          step: 2,
          title: "Prepare Documents",
          description:
            "Gather transcripts, test scores, SOP, and recommendation letters",
          duration: "4-6 weeks",
        },
        {
          step: 3,
          title: "Submit Application",
          description:
            "Apply through university portal or common application systems",
          duration: "1-2 weeks",
        },
        {
          step: 4,
          title: "Pay Application Fee",
          description: "Submit application fees (CAD 50-200 per application)",
          duration: "1 day",
        },
        {
          step: 5,
          title: "Wait for Decision",
          description:
            "Universities review applications and send admission decisions",
          duration: "6-12 weeks",
        },
        {
          step: 6,
          title: "Accept Offer & Pay Fees",
          description: "Accept admission offer and pay tuition deposit",
          duration: "2-3 weeks",
        },
        {
          step: 7,
          title: "Apply for Study Permit",
          description: "Submit visa application with required documents",
          duration: "4-12 weeks",
        },
      ],
    },

    // Cost of Studying - Tuition Fees
    tuitionFees: {
      title: "Cost of Studying in Canada - Tuition Fees",
      undergraduate: {
        title: "Undergraduate Programs",
        fees: [
          { program: "Arts & Humanities", range: "CAD 15,000 - 25,000/year" },
          { program: "Engineering", range: "CAD 20,000 - 35,000/year" },
          { program: "Business", range: "CAD 18,000 - 30,000/year" },
          { program: "Computer Science", range: "CAD 22,000 - 40,000/year" },
          { program: "Medicine", range: "CAD 35,000 - 60,000/year" },
        ],
      },
      postgraduate: {
        title: "Postgraduate Programs",
        fees: [
          { program: "MBA", range: "CAD 30,000 - 80,000/year" },
          { program: "Engineering Masters", range: "CAD 25,000 - 45,000/year" },
          { program: "Arts Masters", range: "CAD 18,000 - 30,000/year" },
          { program: "PhD Programs", range: "CAD 15,000 - 25,000/year" },
        ],
      },
      additionalCosts: {
        title: "Additional Academic Costs",
        costs: [
          { item: "Application Fee", cost: "CAD 50 - 200 per application" },
          { item: "Books & Supplies", cost: "CAD 1,000 - 2,000/year" },
          { item: "Health Insurance", cost: "CAD 600 - 1,200/year" },
          { item: "Student Activity Fees", cost: "CAD 300 - 800/year" },
        ],
      },
    },

    // Top Universities
    topUniversities: {
      title: "Top Universities in Canada",
      universities: [
        {
          name: "University of Toronto",
          ranking: "#1 in Canada, #21 globally",
          location: "Toronto, Ontario",
          specialties: ["Medicine", "Engineering", "Business"],
          tuitionRange: "CAD 25,000 - 60,000/year",
        },
        {
          name: "University of British Columbia",
          ranking: "#2 in Canada, #40 globally",
          location: "Vancouver, BC",
          specialties: ["Computer Science", "Arts", "Applied Science"],
          tuitionRange: "CAD 20,000 - 50,000/year",
        },
        {
          name: "McGill University",
          ranking: "#3 in Canada, #31 globally",
          location: "Montreal, Quebec",
          specialties: ["Medicine", "Law", "Arts"],
          tuitionRange: "CAD 18,000 - 45,000/year",
        },
        {
          name: "University of Alberta",
          ranking: "#4 in Canada, #126 globally",
          location: "Edmonton, Alberta",
          specialties: ["Engineering", "Business", "Medicine"],
          tuitionRange: "CAD 15,000 - 35,000/year",
        },
        {
          name: "University of Waterloo",
          ranking: "#5 in Canada, #166 globally",
          location: "Waterloo, Ontario",
          specialties: ["Computer Science", "Engineering", "Mathematics"],
          tuitionRange: "CAD 20,000 - 40,000/year",
        },
      ],
    },

    // Cost of Living
    costOfLiving: {
      title: "Cost of Living in Canada",
      cities: [
        {
          name: "Toronto",
          housing: "CAD 1,200 - 2,500/month",
          food: "CAD 400 - 600/month",
          transportation: "CAD 150 - 200/month",
          total: "CAD 1,800 - 3,400/month",
        },
        {
          name: "Vancouver",
          housing: "CAD 1,100 - 2,200/month",
          food: "CAD 450 - 650/month",
          transportation: "CAD 120 - 180/month",
          total: "CAD 1,700 - 3,100/month",
        },
        {
          name: "Montreal",
          housing: "CAD 800 - 1,800/month",
          food: "CAD 350 - 500/month",
          transportation: "CAD 90 - 140/month",
          total: "CAD 1,300 - 2,500/month",
        },
        {
          name: "Calgary",
          housing: "CAD 900 - 1,600/month",
          food: "CAD 400 - 550/month",
          transportation: "CAD 110 - 160/month",
          total: "CAD 1,500 - 2,400/month",
        },
      ],
      breakdown: {
        title: "Average Monthly Expenses Breakdown",
        expenses: [
          { category: "Accommodation", range: "CAD 800 - 2,500" },
          { category: "Food & Groceries", range: "CAD 350 - 650" },
          { category: "Transportation", range: "CAD 90 - 200" },
          { category: "Entertainment", range: "CAD 100 - 300" },
          { category: "Phone & Internet", range: "CAD 50 - 100" },
          { category: "Clothing", range: "CAD 50 - 150" },
          { category: "Personal Care", range: "CAD 50 - 100" },
        ],
      },
    },
  },
  {
    name: "usa",
    imageURL:
      "https://images.unsplash.com/photo-1508433957232-3107f5fd5995?q=80&w=2086&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    tagline:
      "Experience world-class education, diverse cultures, and cutting-edge research",

    // Eligibility Requirements
    eligibilityRequirements: {
      title: "Eligibility Requirements to Study in the USA",
      requirements: [
        {
          category: "Academic Requirements",
          items: [
            "Minimum 60-70% in 12th grade for undergraduate programs",
            "Bachelor's degree for postgraduate programs",
            "Transcripts and mark sheets from recognized boards",
          ],
        },
        {
          category: "English Proficiency",
          items: [
            "IELTS: Overall 6.5-7.0 (no band less than 6.0)",
            "TOEFL iBT: 80-100 depending on program",
            "PTE: 58-65 overall score",
            "Duolingo: 105+ (some institutions)",
          ],
        },
        {
          category: "Financial Requirements",
          items: [
            "Proof of funds: USD 25,000-35,000 per year",
            "Tuition fee payment proof",
            "Bank statements for last 6 months",
            "Education loan sanction letter (if applicable)",
          ],
        },
        {
          category: "Additional Documents",
          items: [
            "Valid passport",
            "Statement of Purpose (SOP)",
            "Letters of Recommendation",
            "Resume/CV",
          ],
        },
      ],
    },

    // Application Process
    applicationProcess: {
      title: "Application Process to Study in the USA",
      steps: [
        {
          step: 1,
          title: "Research & Choose Program",
          description:
            "Research universities, programs, and admission requirements",
          duration: "2-3 weeks",
        },
        {
          step: 2,
          title: "Prepare Documents",
          description:
            "Gather transcripts, test scores, SOP, and recommendation letters",
          duration: "4-6 weeks",
        },
        {
          step: 3,
          title: "Submit Application",
          description:
            "Apply through university portal or common application systems",
          duration: "1-2 weeks",
        },
        {
          step: 4,
          title: "Pay Application Fee",
          description: "Submit application fees (USD 50-100 per application)",
          duration: "1 day",
        },
        {
          step: 5,
          title: "Wait for Decision",
          description:
            "Universities review applications and send admission decisions",
          duration: "6-12 weeks",
        },
        {
          step: 6,
          title: "Accept Offer & Pay Fees",
          description: "Accept admission offer and pay tuition deposit",
          duration: "2-3 weeks",
        },
        {
          step: 7,
          title: "Apply for Student Visa (F-1)",
          description: "Submit visa application with required documents",
          duration: "4-12 weeks",
        },
      ],
    },

    // Cost of Studying - Tuition Fees
    tuitionFees: {
      title: "Cost of Studying in the USA - Tuition Fees",
      undergraduate: {
        title: "Undergraduate Programs",
        fees: [
          { program: "Arts & Humanities", range: "USD 20,000 - 40,000/year" },
          { program: "Engineering", range: "USD 30,000 - 50,000/year" },
          { program: "Business", range: "USD 35,000 - 55,000/year" },
          { program: "Computer Science", range: "USD 35,000 - 60,000/year" },
          { program: "Medicine", range: "USD 50,000 - 70,000/year" },
        ],
      },
      postgraduate: {
        title: "Postgraduate Programs",
        fees: [
          { program: "MBA", range: "USD 40,000 - 100,000/year" },
          { program: "Engineering Masters", range: "USD 30,000 - 60,000/year" },
          { program: "Arts Masters", range: "USD 25,000 - 45,000/year" },
          { program: "PhD Programs", range: "USD 20,000 - 50,000/year" },
        ],
      },
      additionalCosts: {
        title: "Additional Academic Costs",
        costs: [
          { item: "Application Fee", cost: "USD 50 - 100 per application" },
          { item: "Books & Supplies", cost: "USD 1,000 - 2,500/year" },
          { item: "Health Insurance", cost: "USD 1,000 - 2,000/year" },
          { item: "Student Activity Fees", cost: "USD 200 - 500/year" },
        ],
      },
    },

    // Top Universities
    topUniversities: {
      title: "Top Universities in the USA",
      universities: [
        {
          name: "Harvard University",
          ranking: "#1 in USA, #3 globally",
          location: "Cambridge, MA",
          specialties: ["Business", "Law", "Medicine"],
          tuitionRange: "USD 50,000 - 70,000/year",
        },
        {
          name: "Stanford University",
          ranking: "#2 in USA, #6 globally",
          location: "Stanford, CA",
          specialties: ["Engineering", "Computer Science", "Business"],
          tuitionRange: "USD 55,000 - 70,000/year",
        },
        {
          name: "MIT",
          ranking: "#3 in USA, #1 globally",
          location: "Cambridge, MA",
          specialties: ["Engineering", "Computer Science", "Mathematics"],
          tuitionRange: "USD 55,000 - 70,000/year",
        },
        {
          name: "University of California, Berkeley",
          ranking: "#4 in USA, #20 globally",
          location: "Berkeley, CA",
          specialties: ["Engineering", "Business", "Arts"],
          tuitionRange: "USD 40,000 - 65,000/year",
        },
        {
          name: "University of Chicago",
          ranking: "#5 in USA, #10 globally",
          location: "Chicago, IL",
          specialties: ["Economics", "Business", "Law"],
          tuitionRange: "USD 50,000 - 70,000/year",
        },
      ],
    },

    // Cost of Living
    costOfLiving: {
      title: "Cost of Living in the USA",
      cities: [
        {
          name: "New York City",
          housing: "USD 1,500 - 3,500/month",
          food: "USD 400 - 700/month",
          transportation: "USD 120 - 200/month",
          total: "USD 2,000 - 4,400/month",
        },
        {
          name: "Los Angeles",
          housing: "USD 1,200 - 2,800/month",
          food: "USD 400 - 600/month",
          transportation: "USD 100 - 180/month",
          total: "USD 1,700 - 3,600/month",
        },
        {
          name: "Chicago",
          housing: "USD 900 - 2,200/month",
          food: "USD 350 - 550/month",
          transportation: "USD 80 - 150/month",
          total: "USD 1,400 - 2,900/month",
        },
        {
          name: "Boston",
          housing: "USD 1,200 - 2,500/month",
          food: "USD 400 - 600/month",
          transportation: "USD 100 - 150/month",
          total: "USD 1,700 - 3,250/month",
        },
      ],
      breakdown: {
        title: "Average Monthly Expenses Breakdown",
        expenses: [
          { category: "Accommodation", range: "USD 900 - 3,500" },
          { category: "Food & Groceries", range: "USD 350 - 700" },
          { category: "Transportation", range: "USD 80 - 200" },
          { category: "Entertainment", range: "USD 100 - 400" },
          { category: "Phone & Internet", range: "USD 50 - 100" },
          { category: "Clothing", range: "USD 50 - 200" },
          { category: "Personal Care", range: "USD 50 - 150" },
        ],
      },
    },
  },
  {
    name: "europe",
    imageURL:
      "https://plus.unsplash.com/premium_photo-1664303991463-36449a65d3d6?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    tagline:
      "Study in historic universities, vibrant cities, and a diverse cultural environment",

    // Eligibility Requirements
    eligibilityRequirements: {
      title: "Eligibility Requirements to Study in Europe",
      requirements: [
        {
          category: "Academic Requirements",
          items: [
            "Minimum 60-70% in 12th grade for undergraduate programs",
            "Bachelor's degree for postgraduate programs",
            "Transcripts and mark sheets from recognized boards",
          ],
        },
        {
          category: "English Proficiency",
          items: [
            "IELTS: Overall 6.5-7.0 (no band less than 6.0)",
            "TOEFL iBT: 80-100 depending on program",
            "PTE: 58-65 overall score",
            "Duolingo: 110+ (some institutions)",
          ],
        },
        {
          category: "Financial Requirements",
          items: [
            "Proof of funds: £12,000-18,000 per year",
            "Tuition fee payment proof",
            "Bank statements for last 6 months",
            "Education loan sanction letter (if applicable)",
          ],
        },
        {
          category: "Additional Documents",
          items: [
            "Valid passport",
            "Statement of Purpose (SOP)",
            "Letters of Recommendation",
            "Resume/CV",
          ],
        },
      ],
    },

    // Application Process
    applicationProcess: {
      title: "Application Process to Study in Europe",
      steps: [
        {
          step: 1,
          title: "Research & Choose Program",
          description:
            "Research universities, programs, and admission requirements",
          duration: "2-3 weeks",
        },
        {
          step: 2,
          title: "Prepare Documents",
          description:
            "Gather transcripts, test scores, SOP, and recommendation letters",
          duration: "4-6 weeks",
        },
        {
          step: 3,
          title: "Submit Application",
          description:
            "Apply through UCAS for undergraduate or university portals for postgraduate",
          duration: "1-2 weeks",
        },
        {
          step: 4,
          title: "Pay Application Fee",
          description:
            "Submit UCAS or university application fees (£20-30 per application)",
          duration: "1 day",
        },
        {
          step: 5,
          title: "Wait for Decision",
          description:
            "Universities review applications and send admission decisions",
          duration: "4-10 weeks",
        },
        {
          step: 6,
          title: "Accept Offer & Pay Fees",
          description: "Accept admission offer and pay tuition deposit",
          duration: "2-3 weeks",
        },
        {
          step: 7,
          title: "Apply for Student Visa (Tier 4 / Student Visa)",
          description: "Submit visa application with required documents",
          duration: "4-12 weeks",
        },
      ],
    },

    // Cost of Studying - Tuition Fees
    tuitionFees: {
      title: "Cost of Studying in Europe - Tuition Fees",
      undergraduate: {
        title: "Undergraduate Programs",
        fees: [
          { program: "Arts & Humanities", range: "£12,000 - 25,000/year" },
          { program: "Engineering", range: "£18,000 - 30,000/year" },
          { program: "Business", range: "£15,000 - 28,000/year" },
          { program: "Computer Science", range: "£18,000 - 32,000/year" },
          { program: "Medicine", range: "£35,000 - 55,000/year" },
        ],
      },
      postgraduate: {
        title: "Postgraduate Programs",
        fees: [
          { program: "MBA", range: "£25,000 - 60,000/year" },
          { program: "Engineering Masters", range: "£20,000 - 40,000/year" },
          { program: "Arts Masters", range: "£18,000 - 35,000/year" },
          { program: "PhD Programs", range: "£15,000 - 30,000/year" },
        ],
      },
      additionalCosts: {
        title: "Additional Academic Costs",
        costs: [
          { item: "Application Fee", cost: "£20 - 30 per application" },
          { item: "Books & Supplies", cost: "£500 - 1,500/year" },
          { item: "Health Insurance (NHS Surcharge)", cost: "£470/year" },
          { item: "Student Activity Fees", cost: "£100 - 300/year" },
        ],
      },
    },

    // Top Universities
    topUniversities: {
      title: "Top Universities in Europe",
      universities: [
        {
          name: "University of Oxford",
          ranking: "#1 in UK, #2 globally",
          location: "Oxford, England",
          specialties: ["Humanities", "Medicine", "Law"],
          tuitionRange: "£30,000 - 50,000/year",
        },
        {
          name: "University of Cambridge",
          ranking: "#2 in UK, #3 globally",
          location: "Cambridge, England",
          specialties: ["Engineering", "Sciences", "Law"],
          tuitionRange: "£28,000 - 50,000/year",
        },
        {
          name: "Imperial College London",
          ranking: "#3 in UK, #8 globally",
          location: "London, England",
          specialties: ["Engineering", "Medicine", "Business"],
          tuitionRange: "£30,000 - 55,000/year",
        },
        {
          name: "London School of Economics",
          ranking: "#4 in UK, #49 globally",
          location: "London, England",
          specialties: ["Economics", "Business", "Social Sciences"],
          tuitionRange: "£25,000 - 45,000/year",
        },
        {
          name: "University College London (UCL)",
          ranking: "#5 in UK, #19 globally",
          location: "London, England",
          specialties: ["Medicine", "Engineering", "Arts"],
          tuitionRange: "£25,000 - 45,000/year",
        },
      ],
    },

    // Cost of Living
    costOfLiving: {
      title: "Cost of Living in Europe",
      cities: [
        {
          name: "London",
          housing: "£1,200 - 2,500/month",
          food: "£300 - 600/month",
          transportation: "£150 - 200/month",
          total: "£1,700 - 3,300/month",
        },
        {
          name: "Manchester",
          housing: "£700 - 1,500/month",
          food: "£250 - 500/month",
          transportation: "£80 - 150/month",
          total: "£1,030 - 2,150/month",
        },
        {
          name: "Edinburgh",
          housing: "£700 - 1,600/month",
          food: "£250 - 500/month",
          transportation: "£80 - 150/month",
          total: "£1,030 - 2,250/month",
        },
        {
          name: "Birmingham",
          housing: "£600 - 1,400/month",
          food: "£250 - 450/month",
          transportation: "£70 - 130/month",
          total: "£920 - 1,980/month",
        },
      ],
      breakdown: {
        title: "Average Monthly Expenses Breakdown",
        expenses: [
          { category: "Accommodation", range: "£600 - 2,500" },
          { category: "Food & Groceries", range: "£250 - 600" },
          { category: "Transportation", range: "£70 - 200" },
          { category: "Entertainment", range: "£50 - 200" },
          { category: "Phone & Internet", range: "£20 - 50" },
          { category: "Clothing", range: "£30 - 100" },
          { category: "Personal Care", range: "£20 - 100" },
        ],
      },
    },
  },
  {
    name: "australia",
    imageURL:
      "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?q=80&w=3030&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    tagline:
      "Discover world-class universities, vibrant cities, and stunning natural landscapes",

    // Eligibility Requirements
    eligibilityRequirements: {
      title: "Eligibility Requirements to Study in Australia",
      requirements: [
        {
          category: "Academic Requirements",
          items: [
            "Minimum 60% in 12th grade for undergraduate programs",
            "Bachelor's degree for postgraduate programs",
            "Transcripts and mark sheets from recognized boards",
          ],
        },
        {
          category: "English Proficiency",
          items: [
            "IELTS: Overall 6.5 (no band less than 6.0)",
            "TOEFL iBT: 79-100 depending on program",
            "PTE: 58-65 overall score",
            "Duolingo: 110+ (some institutions)",
          ],
        },
        {
          category: "Financial Requirements",
          items: [
            "Proof of funds: AUD 20,000-30,000 per year",
            "Tuition fee payment proof",
            "Bank statements for last 6 months",
            "Education loan sanction letter (if applicable)",
          ],
        },
        {
          category: "Additional Documents",
          items: [
            "Valid passport",
            "Statement of Purpose (SOP)",
            "Letters of Recommendation",
            "Resume/CV",
          ],
        },
      ],
    },

    // Application Process
    applicationProcess: {
      title: "Application Process to Study in Australia",
      steps: [
        {
          step: 1,
          title: "Research & Choose Program",
          description:
            "Research universities, programs, and admission requirements",
          duration: "2-3 weeks",
        },
        {
          step: 2,
          title: "Prepare Documents",
          description:
            "Gather transcripts, test scores, SOP, and recommendation letters",
          duration: "4-6 weeks",
        },
        {
          step: 3,
          title: "Submit Application",
          description:
            "Apply through university portal or common application systems",
          duration: "1-2 weeks",
        },
        {
          step: 4,
          title: "Pay Application Fee",
          description: "Submit application fees (AUD 50-150 per application)",
          duration: "1 day",
        },
        {
          step: 5,
          title: "Wait for Decision",
          description:
            "Universities review applications and send admission decisions",
          duration: "6-12 weeks",
        },
        {
          step: 6,
          title: "Accept Offer & Pay Fees",
          description: "Accept admission offer and pay tuition deposit",
          duration: "2-3 weeks",
        },
        {
          step: 7,
          title: "Apply for Student Visa (Subclass 500)",
          description: "Submit visa application with required documents",
          duration: "4-12 weeks",
        },
      ],
    },

    // Cost of Studying - Tuition Fees
    tuitionFees: {
      title: "Cost of Studying in Australia - Tuition Fees",
      undergraduate: {
        title: "Undergraduate Programs",
        fees: [
          { program: "Arts & Humanities", range: "AUD 20,000 - 35,000/year" },
          { program: "Engineering", range: "AUD 30,000 - 50,000/year" },
          { program: "Business", range: "AUD 25,000 - 45,000/year" },
          { program: "Computer Science", range: "AUD 30,000 - 55,000/year" },
          { program: "Medicine", range: "AUD 50,000 - 70,000/year" },
        ],
      },
      postgraduate: {
        title: "Postgraduate Programs",
        fees: [
          { program: "MBA", range: "AUD 40,000 - 90,000/year" },
          { program: "Engineering Masters", range: "AUD 35,000 - 60,000/year" },
          { program: "Arts Masters", range: "AUD 25,000 - 45,000/year" },
          { program: "PhD Programs", range: "AUD 20,000 - 50,000/year" },
        ],
      },
      additionalCosts: {
        title: "Additional Academic Costs",
        costs: [
          { item: "Application Fee", cost: "AUD 50 - 150 per application" },
          { item: "Books & Supplies", cost: "AUD 1,000 - 2,500/year" },
          { item: "Health Insurance (OSHC)", cost: "AUD 500 - 1,200/year" },
          { item: "Student Activity Fees", cost: "AUD 200 - 500/year" },
        ],
      },
    },

    // Top Universities
    topUniversities: {
      title: "Top Universities in Australia",
      universities: [
        {
          name: "University of Melbourne",
          ranking: "#1 in Australia, #18 globally",
          location: "Melbourne, VIC",
          specialties: ["Medicine", "Business", "Engineering"],
          tuitionRange: "AUD 30,000 - 70,000/year",
        },
        {
          name: "Australian National University",
          ranking: "#2 in Australia, #28 globally",
          location: "Canberra, ACT",
          specialties: ["Arts", "Sciences", "Engineering"],
          tuitionRange: "AUD 30,000 - 60,000/year",
        },
        {
          name: "University of Sydney",
          ranking: "#3 in Australia, #35 globally",
          location: "Sydney, NSW",
          specialties: ["Medicine", "Law", "Business"],
          tuitionRange: "AUD 30,000 - 70,000/year",
        },
        {
          name: "University of Queensland",
          ranking: "#4 in Australia, #43 globally",
          location: "Brisbane, QLD",
          specialties: ["Engineering", "Science", "Business"],
          tuitionRange: "AUD 28,000 - 65,000/year",
        },
        {
          name: "University of New South Wales",
          ranking: "#5 in Australia, #45 globally",
          location: "Sydney, NSW",
          specialties: ["Engineering", "Business", "Law"],
          tuitionRange: "AUD 30,000 - 70,000/year",
        },
      ],
    },

    // Cost of Living
    costOfLiving: {
      title: "Cost of Living in Australia",
      cities: [
        {
          name: "Sydney",
          housing: "AUD 1,500 - 3,000/month",
          food: "AUD 400 - 700/month",
          transportation: "AUD 100 - 200/month",
          total: "AUD 2,000 - 3,900/month",
        },
        {
          name: "Melbourne",
          housing: "AUD 1,300 - 2,800/month",
          food: "AUD 400 - 650/month",
          transportation: "AUD 100 - 180/month",
          total: "AUD 1,900 - 3,600/month",
        },
        {
          name: "Brisbane",
          housing: "AUD 1,200 - 2,400/month",
          food: "AUD 350 - 600/month",
          transportation: "AUD 90 - 150/month",
          total: "AUD 1,700 - 3,150/month",
        },
        {
          name: "Canberra",
          housing: "AUD 1,300 - 2,500/month",
          food: "AUD 400 - 600/month",
          transportation: "AUD 90 - 160/month",
          total: "AUD 1,800 - 3,260/month",
        },
      ],
      breakdown: {
        title: "Average Monthly Expenses Breakdown",
        expenses: [
          { category: "Accommodation", range: "AUD 1,200 - 3,000" },
          { category: "Food & Groceries", range: "AUD 350 - 700" },
          { category: "Transportation", range: "AUD 90 - 200" },
          { category: "Entertainment", range: "AUD 100 - 300" },
          { category: "Phone & Internet", range: "AUD 50 - 100" },
          { category: "Clothing", range: "AUD 50 - 150" },
          { category: "Personal Care", range: "AUD 50 - 100" },
        ],
      },
    },
  },
  {
    name: "germany",
    imageURL:
      "https://images.unsplash.com/photo-1528728329032-2972f65dfb3f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    tagline:
      "Experience high-quality education, innovative research, and a rich cultural heritage",

    // Eligibility Requirements
    eligibilityRequirements: {
      title: "Eligibility Requirements to Study in Germany",
      requirements: [
        {
          category: "Academic Requirements",
          items: [
            "Minimum 60-70% in 12th grade for undergraduate programs",
            "Bachelor's degree for postgraduate programs",
            "Transcripts and mark sheets from recognized boards",
            "Some universities may require preparatory courses (Studienkolleg)",
          ],
        },
        {
          category: "English / German Proficiency",
          items: [
            "IELTS: Overall 6.5-7.0 (some programs)",
            "TOEFL iBT: 80-100 depending on program",
            "German language (TestDaF / DSH) required for programs in German",
          ],
        },
        {
          category: "Financial Requirements",
          items: [
            "Proof of funds: approx. €11,000/year",
            "Tuition is mostly free, but semester fees apply (€250 - €500/semester)",
            "Bank statements for last 6 months",
            "Education loan sanction letter (if applicable)",
          ],
        },
        {
          category: "Additional Documents",
          items: [
            "Valid passport",
            "Statement of Purpose (SOP)",
            "Letters of Recommendation",
            "Resume/CV",
            "Health insurance certificate",
          ],
        },
      ],
    },

    // Application Process
    applicationProcess: {
      title: "Application Process to Study in Germany",
      steps: [
        {
          step: 1,
          title: "Research & Choose Program",
          description:
            "Research universities, programs, and admission requirements",
          duration: "2-3 weeks",
        },
        {
          step: 2,
          title: "Prepare Documents",
          description:
            "Gather transcripts, test scores, language certificates, SOP, and recommendation letters",
          duration: "4-6 weeks",
        },
        {
          step: 3,
          title: "Submit Application",
          description:
            "Apply through university portal or via Uni-Assist (for many universities)",
          duration: "1-2 weeks",
        },
        {
          step: 4,
          title: "Receive Admission Letter",
          description:
            "Universities review applications and send admission letters",
          duration: "6-12 weeks",
        },
        {
          step: 5,
          title: "Enroll & Pay Semester Fee",
          description:
            "Accept admission and pay semester contributions (around €250-500)",
          duration: "1-2 weeks",
        },
        {
          step: 6,
          title: "Apply for Student Visa",
          description: "Submit visa application with required documents",
          duration: "4-12 weeks",
        },
        {
          step: 7,
          title: "Arrive & Register at University",
          description:
            "Register in-person at university, open bank account, and arrange housing",
          duration: "1 week",
        },
      ],
    },

    // Cost of Studying - Tuition Fees
    tuitionFees: {
      title: "Cost of Studying in Germany - Tuition Fees",
      undergraduate: {
        title: "Undergraduate Programs",
        fees: [
          {
            program: "Arts & Humanities",
            range: "Mostly free, €250 - 500/semester",
          },
          { program: "Engineering", range: "Mostly free, €250 - 500/semester" },
          { program: "Business", range: "Mostly free, €250 - 500/semester" },
          {
            program: "Computer Science",
            range: "Mostly free, €250 - 500/semester",
          },
          { program: "Medicine", range: "Mostly free, €250 - 500/semester" },
        ],
      },
      postgraduate: {
        title: "Postgraduate Programs",
        fees: [
          { program: "MBA", range: "€20,000 - 40,000/year (some programs)" },
          {
            program: "Engineering Masters",
            range: "Mostly free, €250 - 500/semester",
          },
          {
            program: "Arts Masters",
            range: "Mostly free, €250 - 500/semester",
          },
          {
            program: "PhD Programs",
            range: "Mostly free, €250 - 500/semester",
          },
        ],
      },
      additionalCosts: {
        title: "Additional Academic Costs",
        costs: [
          { item: "Semester Fee", cost: "€250 - 500/semester" },
          { item: "Books & Supplies", cost: "€200 - 500/year" },
          { item: "Health Insurance", cost: "€80 - 100/month" },
          { item: "Student Activity Fees", cost: "€50 - 100/year" },
        ],
      },
    },

    // Top Universities
    topUniversities: {
      title: "Top Universities in Germany",
      universities: [
        {
          name: "Technical University of Munich (TUM)",
          ranking: "#1 in Germany, #50 globally",
          location: "Munich, Bavaria",
          specialties: ["Engineering", "Computer Science", "Natural Sciences"],
          tuitionRange: "Mostly free, €250 - 500/semester",
        },
        {
          name: "University of Heidelberg",
          ranking: "#2 in Germany, #65 globally",
          location: "Heidelberg, Baden-Württemberg",
          specialties: ["Medicine", "Law", "Natural Sciences"],
          tuitionRange: "Mostly free, €250 - 500/semester",
        },
        {
          name: "LMU Munich",
          ranking: "#3 in Germany, #60 globally",
          location: "Munich, Bavaria",
          specialties: ["Arts", "Sciences", "Medicine"],
          tuitionRange: "Mostly free, €250 - 500/semester",
        },
        {
          name: "University of Freiburg",
          ranking: "#4 in Germany, #120 globally",
          location: "Freiburg, Baden-Württemberg",
          specialties: ["Engineering", "Science", "Arts"],
          tuitionRange: "Mostly free, €250 - 500/semester",
        },
        {
          name: "RWTH Aachen University",
          ranking: "#5 in Germany, #145 globally",
          location: "Aachen, North Rhine-Westphalia",
          specialties: ["Engineering", "Computer Science", "Natural Sciences"],
          tuitionRange: "Mostly free, €250 - 500/semester",
        },
      ],
    },

    // Cost of Living
    costOfLiving: {
      title: "Cost of Living in Germany",
      cities: [
        {
          name: "Munich",
          housing: "€700 - 1,500/month",
          food: "€250 - 400/month",
          transportation: "€60 - 100/month",
          total: "€1,010 - 2,000/month",
        },
        {
          name: "Berlin",
          housing: "€500 - 1,200/month",
          food: "€200 - 350/month",
          transportation: "€60 - 100/month",
          total: "€760 - 1,650/month",
        },
        {
          name: "Frankfurt",
          housing: "€600 - 1,300/month",
          food: "€200 - 350/month",
          transportation: "€60 - 100/month",
          total: "€860 - 1,750/month",
        },
        {
          name: "Hamburg",
          housing: "€550 - 1,200/month",
          food: "€200 - 350/month",
          transportation: "€60 - 100/month",
          total: "€810 - 1,650/month",
        },
      ],
      breakdown: {
        title: "Average Monthly Expenses Breakdown",
        expenses: [
          { category: "Accommodation", range: "€500 - 1,500" },
          { category: "Food & Groceries", range: "€200 - 400" },
          { category: "Transportation", range: "€60 - 100" },
          { category: "Entertainment", range: "€50 - 150" },
          { category: "Phone & Internet", range: "€20 - 50" },
          { category: "Clothing", range: "€30 - 80" },
          { category: "Personal Care", range: "€20 - 50" },
        ],
      },
    },
  },
  {
    name: "newzealand",
    imageURL:
      "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    tagline:
      "Study in world-class universities surrounded by breathtaking landscapes and vibrant culture",

    // Eligibility Requirements
    eligibilityRequirements: {
      title: "Eligibility Requirements to Study in New Zealand",
      requirements: [
        {
          category: "Academic Requirements",
          items: [
            "Minimum 60% in 12th grade for undergraduate programs",
            "Bachelor's degree for postgraduate programs",
            "Transcripts and mark sheets from recognized boards",
          ],
        },
        {
          category: "English Proficiency",
          items: [
            "IELTS: Overall 6.0-6.5 (no band less than 5.5-6.0)",
            "TOEFL iBT: 79-100 depending on program",
            "PTE: 55-65 overall score",
            "Duolingo: 110+ (some institutions)",
          ],
        },
        {
          category: "Financial Requirements",
          items: [
            "Proof of funds: NZD 15,000 - 25,000 per year",
            "Tuition fee payment proof",
            "Bank statements for last 6 months",
            "Education loan sanction letter (if applicable)",
          ],
        },
        {
          category: "Additional Documents",
          items: [
            "Valid passport",
            "Statement of Purpose (SOP)",
            "Letters of Recommendation",
            "Resume/CV",
          ],
        },
      ],
    },

    // Application Process
    applicationProcess: {
      title: "Application Process to Study in New Zealand",
      steps: [
        {
          step: 1,
          title: "Research & Choose Program",
          description:
            "Research universities, programs, and admission requirements",
          duration: "2-3 weeks",
        },
        {
          step: 2,
          title: "Prepare Documents",
          description:
            "Gather transcripts, test scores, SOP, and recommendation letters",
          duration: "4-6 weeks",
        },
        {
          step: 3,
          title: "Submit Application",
          description:
            "Apply through university portal or centralized application systems",
          duration: "1-2 weeks",
        },
        {
          step: 4,
          title: "Pay Application Fee",
          description: "Submit application fees (NZD 50-150 per application)",
          duration: "1 day",
        },
        {
          step: 5,
          title: "Wait for Decision",
          description:
            "Universities review applications and send admission decisions",
          duration: "4-10 weeks",
        },
        {
          step: 6,
          title: "Accept Offer & Pay Fees",
          description: "Accept admission offer and pay tuition deposit",
          duration: "2-3 weeks",
        },
        {
          step: 7,
          title: "Apply for Student Visa",
          description: "Submit visa application with required documents",
          duration: "4-12 weeks",
        },
      ],
    },

    // Cost of Studying - Tuition Fees
    tuitionFees: {
      title: "Cost of Studying in New Zealand - Tuition Fees",
      undergraduate: {
        title: "Undergraduate Programs",
        fees: [
          { program: "Arts & Humanities", range: "NZD 22,000 - 30,000/year" },
          { program: "Engineering", range: "NZD 25,000 - 40,000/year" },
          { program: "Business", range: "NZD 23,000 - 35,000/year" },
          { program: "Computer Science", range: "NZD 25,000 - 40,000/year" },
          { program: "Medicine", range: "NZD 50,000 - 70,000/year" },
        ],
      },
      postgraduate: {
        title: "Postgraduate Programs",
        fees: [
          { program: "MBA", range: "NZD 35,000 - 60,000/year" },
          { program: "Engineering Masters", range: "NZD 28,000 - 45,000/year" },
          { program: "Arts Masters", range: "NZD 22,000 - 35,000/year" },
          { program: "PhD Programs", range: "NZD 18,000 - 35,000/year" },
        ],
      },
      additionalCosts: {
        title: "Additional Academic Costs",
        costs: [
          { item: "Application Fee", cost: "NZD 50 - 150 per application" },
          { item: "Books & Supplies", cost: "NZD 800 - 1,500/year" },
          { item: "Health Insurance", cost: "NZD 500 - 1,000/year" },
          { item: "Student Activity Fees", cost: "NZD 200 - 500/year" },
        ],
      },
    },

    // Top Universities
    topUniversities: {
      title: "Top Universities in New Zealand",
      universities: [
        {
          name: "University of Auckland",
          ranking: "#1 in NZ, #85 globally",
          location: "Auckland",
          specialties: ["Business", "Engineering", "Computer Science"],
          tuitionRange: "NZD 22,000 - 40,000/year",
        },
        {
          name: "University of Otago",
          ranking: "#2 in NZ, #170 globally",
          location: "Dunedin",
          specialties: ["Medicine", "Law", "Sciences"],
          tuitionRange: "NZD 20,000 - 38,000/year",
        },
        {
          name: "Victoria University of Wellington",
          ranking: "#3 in NZ, #250 globally",
          location: "Wellington",
          specialties: ["Arts", "Law", "Sciences"],
          tuitionRange: "NZD 18,000 - 35,000/year",
        },
        {
          name: "University of Canterbury",
          ranking: "#4 in NZ, #270 globally",
          location: "Christchurch",
          specialties: ["Engineering", "Sciences", "Business"],
          tuitionRange: "NZD 20,000 - 38,000/year",
        },
        {
          name: "Massey University",
          ranking: "#5 in NZ, #300 globally",
          location: "Palmerston North / Auckland / Wellington",
          specialties: ["Agriculture", "Business", "Sciences"],
          tuitionRange: "NZD 18,000 - 35,000/year",
        },
      ],
    },

    // Cost of Living
    costOfLiving: {
      title: "Cost of Living in New Zealand",
      cities: [
        {
          name: "Auckland",
          housing: "NZD 1,200 - 2,500/month",
          food: "NZD 350 - 600/month",
          transportation: "NZD 100 - 200/month",
          total: "NZD 1,650 - 3,300/month",
        },
        {
          name: "Wellington",
          housing: "NZD 1,100 - 2,200/month",
          food: "NZD 350 - 550/month",
          transportation: "NZD 90 - 180/month",
          total: "NZD 1,540 - 2,930/month",
        },
        {
          name: "Christchurch",
          housing: "NZD 900 - 1,800/month",
          food: "NZD 300 - 500/month",
          transportation: "NZD 80 - 150/month",
          total: "NZD 1,280 - 2,450/month",
        },
        {
          name: "Dunedin",
          housing: "NZD 800 - 1,600/month",
          food: "NZD 300 - 500/month",
          transportation: "NZD 70 - 150/month",
          total: "NZD 1,170 - 2,250/month",
        },
      ],
      breakdown: {
        title: "Average Monthly Expenses Breakdown",
        expenses: [
          { category: "Accommodation", range: "NZD 800 - 2,500" },
          { category: "Food & Groceries", range: "NZD 300 - 600" },
          { category: "Transportation", range: "NZD 70 - 200" },
          { category: "Entertainment", range: "NZD 50 - 200" },
          { category: "Phone & Internet", range: "NZD 40 - 100" },
          { category: "Clothing", range: "NZD 50 - 150" },
          { category: "Personal Care", range: "NZD 30 - 100" },
        ],
      },
    },
  },
];
